import { Link } from 'react-router-dom';
import { videos } from '@/mocks/data';
import VideoCard from '@/components/feature/VideoCard';

export default function FeaturedVideos() {
  const featuredVideos = videos.slice(0, 8);

  return (
    <section className="w-full py-14 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              精选推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              欲火视频编辑团队每日精选优质内容
            </p>
          </div>
          <Link
            to="/category/recommended"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop="">
          {featuredVideos.map((video) => (
            <VideoCard
              key={video.id}
              id={video.id}
              title={video.title}
              category={video.category}
              thumbnail={video.thumbnail}
              duration={video.duration}
              views={video.views}
              rating={video.rating}
            />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/recommended"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
          >
            查看全部精选内容
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}